import * as currencyFormatter from 'currency-formatter';
import { isBoolean, isNumber } from 'lodash';
import { Link } from 'react-router-dom';

const componentType = {
  pay: { label: 'Pay', link: '/pay' },
  view: { label: 'View', link: '/history/invoices?type=INVOICE' },
};

const SummaryPanel = (props) => {
  const { title, amount, amountColor = 'black', type, daysPastDue, hasProject, isPaid, hidden } = props;

  const amountFormatted = currencyFormatter.format(amount, { code: 'USD' });

  const selectedType = componentType[type];

  const url = new URL(selectedType.link, document.baseURI);

  if (isBoolean(hasProject)) {
    url.searchParams.append('hasProject', hasProject);
  }
  if (isNumber(daysPastDue)) {
    url.searchParams.append('daysPastDue', daysPastDue);
  }
  if (isBoolean(isPaid) && type === 'view') {
    url.searchParams.append('isPaid', isPaid);
  }

  const link = url.pathname + url.search;

  return (
    <div className="hui-dashboard-summary d-flex align-items-center pb-3" hidden={hidden}>
      <div className="flex-grow-1">
        <div className={`hui-subtitle hui-color-${amountColor}`}>{amountFormatted}</div>
        <div className="hui-text-xs fw-bold text-uppercase hui-color-gray mb-0">{title}</div>
      </div>
      <Link
        to={link}
        className={`hui-btn hui-btn-rounded hui-btn-${amount === '0' ? 'gray' : 'green'}-light`}
        disabled={amount <= 0}
      >
        {selectedType.label}
      </Link>
    </div>
  );
};

export default SummaryPanel;
